export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};

// Menu permissions constants
export const AVAILABLE_MENU_PERMISSIONS = [
  'inbox',
  'conversations',
  'captain',
  'contacts',
  'companies',
  'reports',
  'canned_responses',
  'campaigns',
  'portals',
  'settings',
];

// Menu labels for display in UI
export const MENU_PERMISSION_LABELS = {
  inbox: 'Inbox',
  conversations: 'Conversations',
  captain: 'Captain',
  contacts: 'Contacts',
  companies: 'Companies',
  reports: 'Reports',
  canned_responses: 'Canned Responses',
  campaigns: 'Campaigns',
  portals: 'Help Center',
  settings: 'Settings',
};

// Default menu permissions for roles
export const DEFAULT_MENU_PERMISSIONS = {
  administrator: AVAILABLE_MENU_PERMISSIONS, // All menus
  agent: ['inbox', 'conversations', 'contacts'], // Limited menus
  super_admin: AVAILABLE_MENU_PERMISSIONS, // All menus
};
